/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersUserResponseDto } from '../../models/users-user-response-dto';

export interface UsersControllerRemove$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the user to delete.
 */
  id: string;
}

export function usersControllerRemove(http: HttpClient, rootUrl: string, params: UsersControllerRemove$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersUserResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, usersControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersUserResponseDto>;
    })
  );
}

usersControllerRemove.PATH = '/o2-users/users/{tenant}/{id}';
